/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreditCardPayment {
  amount?: number;
  attempt?: number;
  authorizationCode?: string;
  authorizationMessage?: string;
  creditCardId?: number;
  creditCardPaymentId?: number;
  creditCardPaymentTypeId?: number;
  dateAuthorized?: Date;
  dateCreated?: Date;
  extraData?: string;
  gatewayId?: number;
  gatewaySubscriberId?: number;
  installments?: number;
  ipAddress?: string;
  lr?: string;
  nsu?: string;
  pan?: string;
  paymentGuid?: string;
  paymentId?: number;
  personId?: number;
  recurrence?: number;
  subscriberId?: number;
  subscriptionTypeId?: number;
  tid?: string;
  transactionStatusId?: number;
}
